import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const Category = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (categoryId === '155' || categoryId === 'psplus') navigate('/psplus', { replace: true });
    else if (categoryId === '30493' || categoryId === 'donates') navigate('/donates', { replace: true });
    else navigate(`/catalog?category=${categoryId}`, { replace: true });
  }, [categoryId, navigate]);

  return null;
};

export default Category;
